var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons8-info 1",
    clipPath: "url(#clip0_1346_2248)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8 0.75C4 0.75 0.75 4 0.75 8C0.75 12 4 15.25 8 15.25C12 15.25 15.25 12 15.25 8C15.25 4 12 0.75 8 0.75ZM8 1.5C11.5875 1.5 14.5 4.4125 14.5 8C14.5 11.5875 11.5875 14.5 8 14.5C4.4125 14.5 1.5 11.5875 1.5 8C1.5 4.4125 4.4125 1.5 8 1.5ZM8 3.75C7.70163 3.75 7.41548 3.86853 7.2045 4.0795C6.99353 4.29048 6.875 4.57663 6.875 4.875C6.875 5.17337 6.99353 5.45952 7.2045 5.6705C7.41548 5.88147 7.70163 6 8 6C8.29837 6 8.58452 5.88147 8.7955 5.6705C9.00647 5.45952 9.125 5.17337 9.125 4.875C9.125 4.57663 9.00647 4.29048 8.7955 4.0795C8.58452 3.86853 8.29837 3.75 8 3.75ZM8 7.375C7.375 7.375 6.875 7.875 6.875 8.5V11.5C6.875 12.125 7.375 12.625 8 12.625C8.625 12.625 9.125 12.125 9.125 11.5V8.5C9.125 7.875 8.625 7.375 8 7.375Z",
    fill: "#666666"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1346_2248"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfo);
export default __webpack_public_path__ + "static/media/iconInfo.cfbe14f949055a23b776235ffbc8070d.svg";
export { ForwardRef as ReactComponent };